import "./GeneralQuestions.scss";
import Accordion from "components/Accordion/Accordion";
import { getGeneralQuestions } from "constants/generalQustions";
import { useTranslation } from "react-i18next";

const GeneralQuestions = () => {
  const { t } = useTranslation();
  return (
    <div className="general-question-container">
      <h2 className="main-title">{t("titles.generalQuestion")}</h2>
      <Accordion content={getGeneralQuestions()} />
    </div>
  );
};
export default GeneralQuestions;
